import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TRemoteDeploymentStore } from '@monorepo/types';

export const selectRemoteDeploymentStore = createFeatureSelector<TRemoteDeploymentStore>('REMOTE_DEPLOYMENT_STORE');
export const getUpdateDetails = createSelector(selectRemoteDeploymentStore, (remoteDeploymentStore) => {
  return remoteDeploymentStore;
});
